"use client"
import "aos/dist/aos.css"

import Title from "../Title/Title"

interface IndustryCardProps {
  title: string
  image: string
  alt: string
  className?: string
  index?: number // Added for staggered delay
}

function IndustryCard({
  title,
  image,
  alt,
  className = "",
  index = 0, // Default to 0 if not provided
}: IndustryCardProps) {
  return (
    <div
      className=""
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay={index * 200}
    >
      <div
        className={`relative w-full h-fit xl:h-[500px] hover:bg-[--color-brand] aos-animate:hover:bg-[--color-brand] transition-colors duration-300 ease-in-out overflow-hidden mb-4 lg:mb-0 cursor-pointer ${className}`}
      >
        <Title
          title={title}
          type="h2"
          className="uppercase text-[24px] xl:text-[34px] 2xl:text-[48px] p-6"
        />
        {image && (
          <img
            src={image}
            alt={alt}
            width={300}
            height={300}
            loading="lazy"
            decoding="async"
            className="w-[150px]  absolute bottom-6 right-6"
          />
        )}
      </div>
    </div>
  )
}

export default IndustryCard
